module.exports = __webpack_public_path__ + "static/media/2026_The-Game-Tile-Logged-In-@1x.126f31f2.webp";